import { Grid2 } from "@mui/material";
import React from "react";

import PlanGraphStyle from "../../Components/PlanGraph/PlanGraphStyle.module.scss";
import PlanEquation from "../PlanEquation/PlanEquation";

const InfoRow = ({ Icon, label, used, total, iconClass }) => (
  <Grid2 className={PlanGraphStyle.infoRow}>
    <Grid2 className={iconClass}>
      <Icon />
    </Grid2>
    <Grid2>
      <Grid2 className={PlanGraphStyle.licenseLabel}>{label}</Grid2>
      <Grid2>
        <PlanEquation used={used} total={total} />
      </Grid2>
    </Grid2>
  </Grid2>
);

export default InfoRow;
